<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">

    <aside class="rope"></aside>
    <app-back-btn></app-back-btn>

    <section class="search-result">

      <div class="inner wrap">

        <app-search-box [placeholder]="placeholder"
                        [keyHistoryKeyword]="HISTORY_KEY_SEARCH_BOARD"
                        [keyword]="keyword"
                        [top]="scrollTop"
                        (search)="onSearch($event)"></app-search-box>

        <div class="search-body-box">


          <article class="book-layout2">

            <div class="book-layout-wrap index-effect">

              <div class="book-page-list">

                <div class="book-page-group">

                  <div class="page-box">
                    <div class="page-contents scroll-effect over-y">

                      <app-board-detail *ngIf="rightArticle"
                                        [article_no]="rightArticle.no"
                                        (close)="onCloseArticle($event)"></app-board-detail>

                      <app-board-list *ngIf="rightArticle === null && pl?.getList()?.length ?? 0 > 0"
                                      [listArticle]="ListLeft"
                                      [selectedNo]="leftArticle?.no ?? null"
                                      (selectArticle)="onSelectArticle($event)"></app-board-list>

                      <div class="no-result" *ngIf="pl?.getList()?.length === 0">
                        <div class="no-result-img"></div>
                        <div class="no-result-txt">포함된 글이 없습니다.</div>
                      </div>

                    </div>

                    <article class="page-navigation">
                      <a class="prev-btn {{ GetPreBtnCss() }}"
                         (click)="goPrevPage($event)"></a>
                    </article>

                  </div>
                  <div class="page-box">

                    <div class="page-contents scroll-effect over-y">

                      <app-board-detail *ngIf="leftArticle"
                                        [article_no]="leftArticle.no"
                                        (close)="onCloseArticle($event)"></app-board-detail>

                      <app-board-list *ngIf="leftArticle === null"
                                      [listArticle]="ListRight"
                                      [selectedNo]="rightArticle?.no ?? null"
                                      (selectArticle)="onSelectArticle($event)"></app-board-list>

                    </div>

                    <article class="page-navigation">
                      <a class="next-btn {{ GetNextBtnCss() }}"
                         (click)="goNextPage($event)"></a>
                    </article>

                  </div>
                </div>


              </div>

            </div>


          </article>

        </div>

      </div>

    </section>


  </div>

  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>


</div>
